export enum WallType {
  LINE = 'line',
  ARC = 'arc',
  CIRCLE = 'circle',
  INTERIOR = 'interior',
}
